export default function waitForPageLoad (timeout = 10000) {
  // Waits for all images to load (max 10s)

  return new Promise(resolve => {
    const timeoutId = setTimeout(() => {
      INKIVE.C.DEBUG && console.warn('waitForPageLoad reached timeout before images loaded.\nIndicates slow network or a BUG');
      resolve();
    }, timeout);
    const images = [...document.querySelectorAll('image')]
      .filter(img => img.parentElement.id !== 'gridpattern'); // #gridpattern isn't part of the design
    let loaded = 0;

    if (!images.length) return onLoad();

    for (let i = 0; i < images.length; i++) {
      const image = images[i];

      const href = image.getAttribute('xlink:href');
      if (!href) return onLoad();

      const clone = new Image();
      clone.addEventListener('load', onLoad);
      clone.src = href;
    }

    function onLoad () {
      loaded++;
      if (!images.length || loaded === images.length) {
        clearTimeout(timeoutId);
        resolve();
        return false;
      }
    }
  });
}
